<template>
  <a-row class="content-fix org">
    <a-row class="content-title" type="flex">
      <a-button
        type="primary"
        class="back-btn"
        @click="$router.push({ name: 'mtms' })"
      >
        <i class="t-transition icons icon-chevron-left" />
        Назад
      </a-button>
    </a-row>

    <a-table
      :key="$route.fullPath"
      :columns="columns"
      :data-source="tableProps"
    >
      <template slot="name" slot-scope="item">
        <div
          style="cursor: pointer"
          @click="
            $router.push({
              name: item.name,
              params: {
                id: item.id
              }
            })
          "
        >
          {{ item.title[$i18n.locale] }}
        </div>
      </template>
    </a-table>
  </a-row>
</template>

<script>
// import searchInput from "@/components/wanted/search-input"

const columns = [
  {
    title: "Название",
    key: "title",
    class: "wanted-fio-td",
    scopedSlots: {
      customRender: "name"
    }
  }
]

export default {
  data: () => ({
    tableProps: [
      {
        title: {
          uz: "Umumiy hukumat",
          oz: "Умумий ҳукумат",
          ru: "Генеральное правительство",
          en: "General government"
        },
        id: 1,
        name: "mtms-general"
      },
      {
        title: {
          uz: "Markaziy hukumat",
          oz: "Марказий ҳукумат",
          ru: "Центральное правительство",
          en: "Central government"
        },
        id: 2,
        name: "mtms-central"
      }
    ],
    columns
  }),
  methods: {}
}
</script>
<style>
.wanted-search-input-wrapper {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 430px;
  flex: 0 0 430px;
  justify-content: space-around;
}

/*.ministry .ant-table-pagination.ant-pagination {
  display: none;
}*/
</style>
